var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"transform-origin":"center center","width":"29px","height":"40px"},style:({
    transform: _vm.rotation,
    width: (_vm.computedWidth + "px"),
    height: (_vm.computedHeight + "px"),
  })},[_c('svg',{attrs:{"height":"100%","width":"100%","viewBox":"0 0 29 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.83066 40H0V0H7.83066C19.5103 0.1849 29 9.06009 29 20.0308C29 30.9399 19.5103 39.8151 7.83066 40Z","fill":"currentColor"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }